import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';
import BtnRightSideText from '../../../Shared/Buttons/BtnRightSideText';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {lobbyTabsEnum} from '../cellcomAbroadVariables';

const SelectedCountryIsNotSupportedInPackagePopupContent = (props) => {
  const {selectedCountries, notSupportedCountries} = props;

  const removeSelectedPackage = () => {
    switch (props.activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        gaEvent(
          gaParams
            .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .category,
          gaParams
            .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .eventType,
          gaParams
            .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .eventParams
        );
        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (props.isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_FROMPACKAGECOUNTRYUNSUPPORTEDSEARCHPACKAGE_CLICK.category,
            gaParams.SEPARATED_FROMPACKAGECOUNTRYUNSUPPORTEDSEARCHPACKAGE_CLICK.eventType,
            gaParams.SEPARATED_FROMPACKAGECOUNTRYUNSUPPORTEDSEARCHPACKAGE_CLICK.eventParams
          );
        } else {
          gaEvent(
            gaParams
              .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .category,
            gaParams
              .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .eventType,
            gaParams
              .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_SEARCH_PACKAGE_REGARDING_TO_SELECTED_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .eventParams
          );
        }
        break;
      default:
        break;
    }
    props.setSelectedAbroadPackage(null);
    props.saveNotSupportedCountries(null);
    props.closeModal();
  };

  const continueWithSelected = () => {
    switch (props.activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        gaEvent(
          gaParams
            .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .category,
          gaParams
            .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .eventType,
          gaParams
            .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_PRIVATE_FROM_PACKAGE
            .eventParams
        );
        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (props.isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_FROMPACKAGECOUNTRYUNSUPPORTEDCONTINUE_CLICK.category,
            gaParams.SEPARATED_FROMPACKAGECOUNTRYUNSUPPORTEDCONTINUE_CLICK.eventType,
            gaParams.SEPARATED_FROMPACKAGECOUNTRYUNSUPPORTEDCONTINUE_CLICK.eventParams
          );
        } else {
          gaEvent(
            gaParams
              .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .category,
            gaParams
              .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .eventType,
            gaParams
              .ABROAD_LOBBY_SELECT_COUNTRIES_TAB_COUNTRY_IS_UNSUPPORTED_POPUP_CONTINUE_WITH_SELECTED_PACKAGE_BUTTON_CLICK_BUSINESS_FROM_PACKAGE
              .eventParams
          );
        }
        break;
      default:
        break;
    }
    props.closeModal();
    props.getNextStep();
  };
  return (
    <Container
      className={`not-supported-countries-popup ${
        !isMobile || (isTablet && !props.data.isPortrait) || !props.isSmallResolution ? 'p-0' : ''
      }`}>
      <Row className='not-supported-countries-popup__upper-text'>
        <Col xs={12} className='text-center'>
          <span className='d-block bold'>
            {notSupportedCountries.map((country, index) => {
              return (
                <span className='ml-1' key={index}>
                  {country.countryHebName}
                  {index < notSupportedCountries.length - 1 ? ',' : ''}
                </span>
              );
            })}
          </span>
          <span className='d-block'>לא כלולה בחבילה שבחרתם</span>
        </Col>
      </Row>
      <Row className='not-supported-countries-popup__middle-text'>
        <Col xs={12} className='text-center'>
          <span className='bold'>אנחנו ממליצים</span>
        </Col>
      </Row>
      <Row className='not-supported-countries-popup__bottom-text'>
        <Col xs={12} className='text-center'>
          <span className='bold d-block newPurple'>לחפש חבילה עם כל היעדים שבחרתם:</span>
          <span className='d-block'>
            {selectedCountries.map((country, index) => {
              return (
                <span className='newPurple ml-1' key={index}>
                  <bdi>{country.countryHebName}</bdi>
                  {index < selectedCountries.length - 1 ? ',' : ''}
                </span>
              );
            })}
          </span>
        </Col>
      </Row>
      <Row>
        <Col className='mb-3'>
          <BtnRightSideText
            text={`לבחירת חבילה עם כל היעדים`}
            isDisplayArrows={true}
            onclick={() => removeSelectedPackage()}
            customClass='not-supported-countries-popup__button'
          />
        </Col>
      </Row>
      <Row className='not-supported-countries-popup__gray-button-row'>
        <Col className={`${isMobile || (isTablet && props.data.isPortrait) || props.isSmallResolution ? 'col-12' : 'col-2 p-0'}`}>
          <span className='ORasBtn'>או</span>
        </Col>
        <Col className={`${isMobile || (isTablet && props.data.isPortrait) || props.isSmallResolution ? 'col-12 p-0' : 'col-10'}`}>
          <BtnRightSideText
            text={`המשך עם החבילה שבחרתם`}
            isGreyBg={true}
            isDisplayArrows={true}
            onclick={() => continueWithSelected()}
            customClass='not-supported-countries-popup__gray-button'
          />
        </Col>
      </Row>
    </Container>
  );
};

export default SelectedCountryIsNotSupportedInPackagePopupContent;
